export const TEXT_FILL_STYLE = '#606266'

export const BORDER_STYLE = [96, 98, 102]

export const SPLIT_LINE_STYLE = [235, 238, 245]

export const WIND_PROFILE_TOOLTIP_BORDER_STYLE = [96, 98, 102]

export const TOOLTIP_BORDER_STYLE = [0, 0, 0]

export const FONT_SIZE = 13

export const AXIS_FONT = `${FONT_SIZE}px Times New Roman`

export const MAIN_AXIS_SIZE = 8

export const SUB_AXIS_SIZE = 4

export const X_AXIS_INTERVAL = 6

export const Y_AXIS_INTERVAL = 6

export const LEGEND_BORDER_COLOR = '#DCDFE6'

export const LINE_WIDTH = 2

export const VALUE_INTERVAL = 6



// WEBPACK FOOTER //
// ./src/components/Data/Charts/chartStyle.js